module.exports = __webpack_public_path__ + "media/post-listing-block-5-overlay@2x.aec1ac33.webp";